// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum HardwareYear {
    UNDEFINED = 0,
    HARDWARE_2021 = 2021,
    HARDWARE_2022 = 2022,
    HARDWARE_2023 = 2023,
    HARDWARE_2024 = 2024,
}
export default HardwareYear;
